import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, effect } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { PortalService } from '../../../../../../services/portal.service';
import SignaturePad from 'signature_pad';
import { EnrollmentFormService } from '../../../../../../services/EnrollmentFormService';
import { EnrollmentComponent } from '../enrollment/enrollment.component';
import { environment } from '../../../../../../environments/environment';
import { TelemetryService } from '../../../../../../services/telemetry.service';
import { fileUpload } from '../../../../../helpers/fileUpload.validator';
import { maxFileUploadSize } from '../../../../../helpers/maxFileUploadSize.validator';

@Component({
  selector: 'app-income-info',
  templateUrl: './income-info.component.html',
  styleUrls: ['./income-info.component.scss']
})
export class IncomeInfoComponent implements OnInit {
  @ViewChild('canvas', { static: false }) signaturePadElement!: ElementRef<HTMLCanvasElement>;
  _isSignatureAccepted: boolean = false;
  _isValidToProceed: boolean = false;
  signaturePad!: SignaturePad;
  incomeForm!: FormGroup;
  selectedFiles: {
    file: File;
    preview: string;
    description: string;
    name: string;
    type: string;
    attachmentId?: number;
  }[] = [];
  selectedSignatures: {
    file: File;
    preview: string;
    description: string;
    name: string;
    type: string;
    attachmentId?: number;
  }[] = [];
  enrollmentId: any;
  manufacturerId = environment.manufacturerID;
  enrollmentForm: any;
  incomeHeader: any;
  incomeOtpion1Text: any;
  incomeOtpion2Text: any;
  verificationText: any;
  isFileUploading: boolean = false;
  currentSequenceStep: string;
  isLoading = false;
  editFlow = false;
  isIncomeDocumentTouched: boolean = false;

  incomeDocument = new FormControl('');
  incomeSignature = new FormControl('');

  get isSignatureAccepted(): boolean{
    return this._isSignatureAccepted;
  }

  set isSignatureAccepted(value: boolean){
    this._isSignatureAccepted = value;
    if(value)
      this.updateSelectedSignatures();
  }

  get isValidToProceed(): boolean{
    return this._isValidToProceed;
  }

  set isValidToProceed(value:boolean){
    this._isValidToProceed = value;
  }

  updateSelectedSignatures(){
    this.selectedSignatures = [];
    this.portalService.getEnrollmentAttachment(this.enrollmentId).subscribe({
      next: (data: any) => {
        const signature = data.find((attachment: any) => attachment.enrollmentAttachmentTypeId === 6);
        if (signature) {
          let name = signature.filePath.split('/').pop();
          let type = signature.filePath.split('.').pop();
          this.selectedSignatures.push({
            file: new File([], name),
            preview: 'data:image/png;base64,' + signature.fileDocumentBase64Content,
            name,
            type: type === "pdf" ? "pdf" : "image",
            description: signature.description,
            attachmentId: signature.attachmentId,
          });
        }
      },
      error: (error: any) => {
        console.error('Error fetching attachments:', error);
      }
    }); 
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private portalService: PortalService,
    public efs: EnrollmentFormService,
    private enrollmentComponent: EnrollmentComponent,
    private telemetryService: TelemetryService
  ) {
    this.incomeForm = this.efs.enrollmentForm as FormGroup;
  }
  validateForm(): void {
    const incomeControl = this.incomeForm.get('enrollmentEligibilityDTO.income');
    const householdControl = this.incomeForm.get('enrollmentEligibilityDTO.household');

    // Validate textboxes are not null, not zero, and are valid
    const isIncomeValid = incomeControl?.value !== null && incomeControl.value !== '' && incomeControl.value >= 0 && incomeControl.valid;
    const isHouseholdValid = householdControl?.value && householdControl.value > 0 && householdControl.valid;

    const incomeVerificationOptionControl = this.incomeForm.get('enrollmentEligibilityDTO.incomeVerificationOption');
    const selectedOption = incomeVerificationOptionControl?.value;

    // Ensure base validations
    let isOptionValid = false;
    if (selectedOption === '1') {
      isOptionValid = this.isSignatureAccepted;
    } else if (selectedOption === '2') {
      isOptionValid = this.selectedFiles.length > 0;
    }

    this.isValidToProceed = isIncomeValid && isHouseholdValid && incomeVerificationOptionControl?.valid &&
      isOptionValid;
    this.cdr.detectChanges();
  }


  ngOnInit(): void {
    this.incomeForm = this.efs.enrollmentForm as FormGroup;
    this.incomeForm.valueChanges.subscribe(() => {
      this.validateForm();
    });
    this.currentSequenceStep = localStorage.getItem('CurrentEnrollmentStep');
    this.efs.enrollmentID$.subscribe((id) => {
      this.enrollmentId = id;
    });
    this.route.paramMap.subscribe(params => {
      if (params.get('id')) {
        this.enrollmentId = params.get('id');
        this.editFlow = true;
      }
    });
    this.efs.checkAndfetchEnrollmentDetails(this.enrollmentId);
    this.setSpecificContent();
    const incomeVerificationControl = this.incomeForm.get('enrollmentEligibilityDTO.incomeVerificationOption');
    if (incomeVerificationControl) {
      this.incomeDocument.setValidators([Validators.required]);
      this.incomeSignature.setValidators([Validators.required]);
      this.incomeDocument.updateValueAndValidity();
      this.incomeSignature.updateValueAndValidity();
      incomeVerificationControl.valueChanges.subscribe((value) => {
        if (value === '1') {
          this.incomeDocument.clearValidators();
          this.incomeDocument.updateValueAndValidity();
          if (this.selectedFiles.length) {
            this.removeFile(0);
            this.validateForm();
          }
          this.cdr.detectChanges();
          this.initializeSignaturePad();
        } else {
          if(this.selectedSignatures.length){
            this.removeSignature(0);
          }
        }
      });
    }

    if (this.efs.currentEnrollmentObject?.enrollmentAttachmentViewDTOs?.length) {
      const document = this.efs.currentEnrollmentObject?.enrollmentAttachmentViewDTOs.find((attachment: any) => attachment.enrollmentAttachmentTypeId === 5);
      if (document) {
        this.incomeDocument.setValue(document.attachmentId.toString());
        this.incomeDocument.updateValueAndValidity();
        let name = document.filePath.split('/').pop();
        let type = document.filePath.split('.').pop();
        this.selectedFiles.push({
          file: new File([], name),
          preview: 'data:image/png;base64,' + document.fileDocumentBase64Content,
          name,
          type: type === "pdf" ? "pdf" : "image",
          description: document.description,
          attachmentId: document.attachmentId,
        });
      }

      const signature = this.efs.currentEnrollmentObject?.enrollmentAttachmentViewDTOs.find((attachment: any) => attachment.enrollmentAttachmentTypeId === 6);
      if (signature) {
        let name = signature.filePath.split('/').pop();
        let type = signature.filePath.split('.').pop();
        this.selectedSignatures.push({
          file: new File([], name),
          preview: 'data:image/png;base64,' + signature.fileDocumentBase64Content,
          name,
          type: type === "pdf" ? "pdf" : "image",
          description: signature.description,
          attachmentId: signature.attachmentId,
        });
      }
    }  
  }

  get nextStep() {
    return this.efs.getNextStep();
  }

  ngAfterViewInit(): void {
    this.initializeSignaturePad();
    this.validateForm();
  }
  private initializeSignaturePad(): void {
    if (this.signaturePadElement?.nativeElement) {
      this.signaturePad = new SignaturePad(this.signaturePadElement.nativeElement, {
        minWidth: 0.5,
        maxWidth: 1,
        penColor: 'rgb(0, 0, 0)',
      });

      if (this.efs.currentEnrollmentObject?.enrollmentAttachmentViewDTOs?.length) {
        const sign = this.efs.currentEnrollmentObject?.enrollmentAttachmentViewDTOs.find((attachment: any) => attachment.enrollmentAttachmentTypeId === 6);
        if (sign) {
          this.incomeSignature.setValue("1");
          this.incomeSignature.markAsTouched();
          this.incomeSignature.updateValueAndValidity();
          const base64Sign = 'data:image/png;base64,' + sign.fileDocumentBase64Content
          this.incomeForm.patchValue({ signature: base64Sign });
          this.signaturePad.fromDataURL(base64Sign);
          this.isSignatureAccepted = true;
          this.signaturePad.off();
        }
      }
    } else {
      console.error('Canvas element not found for SignaturePad initialization');
    }
  }

  acceptSignature(): void {
    if (!this.signaturePad.isEmpty()) {
      this.telemetryService.logEvent('Accept Signature Clicked', {
        step: 'Income',
        timestamp: new Date().toISOString(),
      });
      const base64Signature = this.signaturePad.toDataURL();
      this.incomeForm.patchValue({ signature: base64Signature });

      const signatureBlob = this.base64ToBlob(base64Signature);
      const formData = new FormData();
      formData.append('EnrollmentId', this.enrollmentId.toString());
      formData.append('ManufacturerId', this.manufacturerId.toString());
      formData.append('EnrollmentAttachmentDocumentDTOs[0].EnrollmentAttchmentTypeId', '6');
      formData.append('EnrollmentAttachmentDocumentDTOs[0].Description', `Income_Signature`);
      formData.append('EnrollmentAttachmentDocumentDTOs[0].FileDocument', signatureBlob, `income_signature.png`);

      this.portalService.uploadDocumentAttachment(formData).subscribe({
        next: (response) => {
          this.incomeSignature.setValue("1");
          this.incomeSignature.markAsTouched();
          this.incomeSignature.updateValueAndValidity();
          this.isSignatureAccepted = true;
          this.validateForm(); // Trigger re-validation
          this.signaturePad.off(); // Disable drawing on the signature pad
        },
        error: (error) => {
          console.error('Error uploading signature:', error);
        }
      });
    } else {
      console.log('Signature pad is empty.');
    }
  }

  clearSignature(): void {
    this.telemetryService.logEvent('Clear Signature Clicked', {
      step: 'Income',
      timestamp: new Date().toISOString(),
    });
    this.removeSignature(0);
  }

  base64ToBlob(base64: string): Blob {
    const byteString = atob(base64.split(',')[1]);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const intArray = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      intArray[i] = byteString.charCodeAt(i);
    }
    return new Blob([intArray], { type: 'image/png' });
  }

  onFilesSelected(event: any): void {
    const files: FileList = event.target.files;
    this.incomeDocument.clearValidators();
    this.incomeDocument.setValidators([
      Validators.required,
      fileUpload(files),
      maxFileUploadSize(files)
    ]);
    this.incomeDocument.updateValueAndValidity();

    if (!this.incomeDocument?.errors?.['maxFileUploadSize'] && !this.incomeDocument?.errors?.['fileUpload'] && files.length > 0) {
      const file = files[0]; // Only allow the first file

      // Check if a file is already uploaded
      if (this.selectedFiles.length > 0) {
        console.warn('Only one file can be uploaded at a time.');
        return;
      }

      // Check for duplicate file
      if (this.selectedFiles.some((selected) => selected.file.name === file.name)) {
        console.warn(`File "${file.name}" is already selected.`);
        return;
      }

      const reader = new FileReader();
      reader.onload = (e: any) => {
        const description = "Income_Proof"; // Static description

        this.selectedFiles.push({
          file,
          preview: e.target.result,
          name: file.name,
          type: file.type.startsWith('image') ? 'image' : 'pdf',
          description,
        });


        // Disable file input
        const fileInput = document.getElementById('fileUpload') as HTMLInputElement;
        if (fileInput) {
          fileInput.disabled = true;
        }

        this.uploadFile(file, description);
      };
      reader.readAsDataURL(file);
    }
  }

  uploadFile(file: File, description: string): void {
    const formData = new FormData();
    formData.append('EnrollmentId', this.enrollmentId.toString());
    formData.append('ManufacturerId', this.manufacturerId.toString());
    formData.append('EnrollmentAttachmentDocumentDTOs[0].EnrollmentAttchmentTypeId', '5'); // Type ID for Income Proof
    formData.append('EnrollmentAttachmentDocumentDTOs[0].Description', description);
    formData.append('EnrollmentAttachmentDocumentDTOs[0].FileDocument', file, file.name);

    this.isFileUploading = true;

    this.portalService.uploadDocumentAttachment(formData).subscribe({
      next: (response) => {
        if (Array.isArray(response) && response.length > 0) {
          this.validateForm();
          const documentAttachmentId = response[0].id;
          const uploadedFile = this.selectedFiles.find((f) => f.description === description);
          if (uploadedFile) {
            this.incomeDocument.setValue(documentAttachmentId);
            this.incomeDocument.markAsTouched();
            this.incomeDocument.updateValueAndValidity();
            uploadedFile.attachmentId = documentAttachmentId;
          }
        }
        this.isFileUploading = false;
      },
      error: (error) => {
        console.error('Error uploading file:', error);
        this.isFileUploading = false;
      }
    });
  }

  removeFile(index: number): void {
    const fileToRemove = this.selectedFiles[index];
    this.incomeDocument.setValue('');
    this.incomeDocument.markAsTouched();
    this.incomeDocument.updateValueAndValidity();
    this.selectedFiles.splice(index, 1);
    this.validateForm();

    // Re-enable file input
    const fileInput = document.getElementById('fileUpload') as HTMLInputElement;
    if (fileInput) {
      fileInput.disabled = false;
      fileInput.value = '';
    }

    if (!fileToRemove.attachmentId) {
      console.error('Attachment ID not found for the file:', fileToRemove);
      return;
    }

    this.portalService.removeDocumentAttachment(fileToRemove.attachmentId).subscribe({
      next: (response) => {
        console.log('Document removed successfully:', response);
      },
      error: (error) => {
        console.error('Error removing document:', error);
      }
    });
  }

  removeSignature(index: number): void {
    const fileToRemove = this.selectedSignatures[index];

    this.selectedSignatures.splice(index, 1);

    if(fileToRemove){
      if (!fileToRemove.attachmentId) {
        console.error('Attachment ID not found for the file:', fileToRemove);
        return;
      }

      this.portalService.removeDocumentAttachment(fileToRemove.attachmentId).subscribe({
        next: (response) => {
          this.signaturePad.clear();
          this.signaturePad.on();
          this.isSignatureAccepted = false;
          this.incomeForm.patchValue({ signature: '' });
          this.incomeSignature.setValue("");
          if(this.incomeSignature.untouched)
            this.incomeSignature.markAsTouched();
          this.incomeSignature.clearValidators();

          // Trigger change detection
          this.cdr.detectChanges();
          this.validateForm();

        },
        error: (error: any) => {
          console.error('Error removing document:', error);
          this.validateForm();
        }
      });
    }
    else{
      this.signaturePad.clear();
      this.signaturePad.on();
      this.isSignatureAccepted = false;
      this.incomeForm.patchValue({ signature: '' });
      this.incomeSignature.setValue("");
      this.incomeSignature.markAsTouched();
      this.incomeSignature.updateValueAndValidity();

      // Trigger change detection
      this.cdr.detectChanges();
    }
  }

  setSpecificContent(): void {
    this.portalService.getDataByConsentType('Income Verification Header').subscribe(data => {
      if (data.length) this.incomeHeader = data[0].contentText;
    });

    this.portalService.getDataByConsentType('Income Verification Option1 Text').subscribe(data => {
      if (data.length) this.incomeOtpion1Text = data[0].contentText;
    });

    this.portalService.getDataByConsentType('Income Verification Option2 Text').subscribe(data => {
      if (data.length) this.incomeOtpion2Text = data[0].contentText;
    });
    this.portalService.getDataByConsentType('Income Verification Option1 Agreement Text').subscribe(data => {
      if (data.length) this.verificationText = data[0].contentText;
    });
  }

  onSave(isSaveAndExit = false): void {
    if(!isSaveAndExit) {
			this.telemetryService.logEvent('Next Button Clicked', {
				step: this.nextStep.enrollmentStepName,
				timestamp: new Date().toISOString(),
			});
		}

    this.isLoading = true;
    this.incomeForm.patchValue({
      lastEnrollmentStep: this.currentSequenceStep
    });
    this.portalService.createEnrollment(this.incomeForm.value, this.enrollmentId).subscribe((value: any) => {
      this.isLoading = false;
      this.efs.patchEnrollmentForm(value);
      this.efs.setEnrollmentID(value.enrollmentId);
      this.incomeForm.patchValue({
        enrollmentId: value.enrollmentId
      });
      if (isSaveAndExit) {
        this.efs.resetForm();
        this.router.navigate(['/submissions'], { relativeTo: this.route });
      } else {
        if (this.editFlow) {
          this.router.navigate([`../${this.nextStep.enrollmentRoute}`], { relativeTo: this.route });
          this.enrollmentComponent.setCurrentStep(this.nextStep.enrollmentStepName, 'true');
        } else {
          this.enrollmentComponent.setCurrentStep(this.nextStep.enrollmentStepName);
        }
      }
    });
  }
}
